import { queryOptions, useQuery } from "@tanstack/react-query";
import { computeRedirectUri } from "@/app/oauth/utils";
import { experienceApi } from "@/lib/api";

const callbackUrlTemplateQueryOptions = () =>
  queryOptions<string>({
    queryKey: ["config", "callback-url-template"],
    // The callback URL template is an infra constant that essentially never
    // changes at runtime. Fetching it once per session is sufficient.
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async () => {
      const { data } = await experienceApi.get<{ callbackUrlTemplate: string }>(
        "/api/config/callback-url-template"
      );
      return data.callbackUrlTemplate;
    },
  });

/**
 * Returns the computed redirect URI for a given external ID, or undefined
 * while the callback URL template is still loading.
 */
export const useComputedRedirectUri = (externalId: string) => {
  const { data: callbackUrlTemplate, isLoading } = useQuery(
    callbackUrlTemplateQueryOptions()
  );

  const redirectUri = callbackUrlTemplate
    ? computeRedirectUri(callbackUrlTemplate, externalId)
    : undefined;

  return { redirectUri, isLoading };
};
